import {TriggerUpdateTableDataType} from './actionTypes';

const triggerUpdateTableData = (dispatch, data) => {
  dispatch({type: TriggerUpdateTableDataType.TRIGGER, data});
};

export {triggerUpdateTableData};
